import offCanvasControls from 'views/assets/scripts/offCanvasControls'
import mountOffCanvasContainer from 'views/containers/browser/OffCanvasContainer/mountOffCanvasContainer'

export default () => {
  const offCanvas = offCanvasControls()
  mountOffCanvasContainer(offCanvas.show)
}
